import React, { Fragment, useState, useEffect } from "react";
import moment from "moment";
import MsgDataService from "../../services/MsgService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import swal from 'sweetalert';
import { Tooltip } from "@mui/material";
// Import modern UI assets like MsgListComponent
import profileIcon from "../../assets/images/CouselorMessages/profile.png";
import deleteIcon from "../../assets/images/CouselorMessages/delete.png";
const IMG_URL = process.env.REACT_APP_IMAGE_ASSET_URL;

const MessageList = ({
  data,
  selectMessage,
  selectedMessageIndex,
  getMsgData,
  searchList,
  notificationData, // Add notification data prop like MsgListComponent
  count, // Keep count for compatibility
  openClickedContact // Keep openClickedContact for compatibility
}) => {
  const [dataList, setDataList] = useState([]);

  // Function to get individual notification count like MsgListComponent
  const getIndividualNotificationCount = (item) => {
    if (!notificationData) return 0;
    
    let count = 0;
    const itemId = item?.src_id || item?.id;
    
    if (notificationData?.student && notificationData.student[itemId]) {
      count = notificationData.student[itemId];
    } else if (notificationData?.counselor && notificationData.counselor[itemId]) {
      count = notificationData.counselor[itemId];
    } else if (notificationData?.international && notificationData.international[itemId]) {
      count = notificationData.international[itemId];
    }
    
    return count;
  };
  // const messageBody = (item) => {
  //   let count = Object.keys(item).length;
  //   let messageBody;
  //   messageBody = item && item[`${count}`].body;
  //   return messageBody;
  // };

  // const messageDate = (item) => {
  //   // console.log(item)
  //   let count = Object.keys(item)?.length;
  //   let messageDate1;
  //   messageDate1 = item && item[`${count}`].date_sent;
  //   messageDate1 = moment(messageDate1).format("ddd MMM Do YYYY, hh:mm:ss a");
  //   return messageDate1;
  // };

  const onSelectedDelete = (e, item) => {
    e.stopPropagation();
    
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this message!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        let body = {
          message_id: item && item.id,
        };
        
        MsgDataService.deleteRecruiterMsg(body)
          .then((data) => {
            console.log("data from the delete service", data);
            swal("Message deleted successfully!", {
              icon: "success",
            });
            getMsgData && getMsgData(); // Call getMsgData if available
          })
          .catch((error) => {
            console.log("error from service", error);
            swal("Error deleting message!", {
              icon: "error",
            });
          });
      }
    });
  };

  // const showAttachment = (item) => {
  //   let count = Object.keys(item).length;
  //   if (item?.[count]?.attachment) {
  //     return (
  //       <div>
  //         <a
  //           className="download-attachment-anchor"
  //           target="_blank"
  //           href={item?.[count].attachment}
  //         >
  //           <span className="flex download-attachment">
  //             <FontAwesomeIcon
  //               style={{ marginRight: "7px" }}
  //               icon={faDownload}
  //             />
  //             <p className="no-margin-bottom">Download Attachment</p>
  //           </span>
  //         </a>
  //       </div>
  //     );
  //   }
  // };;

  useEffect(() => {
    if (searchList) {
      setDataList(searchList)
    } else {
      setDataList(data?.data || [])
    }
  }, [searchList, data])

  // const showAttachment = (item) => {
  //   let count = Object.keys(item).length;
  //   if (item?.[count]?.file_data?.url) {
  //     return (
  //       <div>
  //         <a
  //           className="download-attachment-anchor"
  //           target="_blank"
  //           href={item?.[count].file_data?.url}
  //         >
  //           <span className="flex download-attachment">
  //             <FontAwesomeIcon
  //               style={{ marginRight: "7px" }}
  //               icon={faDownload}
  //             />
  //             <p className="no-margin-bottom">
  //               {/* Download Attachment */}
  //               {item?.[count].file_data?.file_name}
  //               </p>
  //           </span>
  //         </a>
  //       </div>
  //     );
  //   }
  // };
//  console.log("dataList", dataList);
  return (
    <Fragment>
      {dataList?.length > 0 ? (
        dataList.map((item, index) => {
          return (
            <div
              key={item.src_id || item.id}
              onClick={() => {
                // Support both selectMessage and openClickedContact
                if (selectMessage) {
                  selectMessage(item, index);
                } else if (openClickedContact) {
                  openClickedContact(item);
                }
              }}
              className={`single_msg_container ${index === selectedMessageIndex ? 'selected' : ''}`}
              style={{
                border: '2px solid #2cb34a',
                background: index === selectedMessageIndex ? '#ffffff' : '#E5F4E4',
                transition: 'background 0.2s ease',
                borderRadius: '28px',
                padding: '10px 0 5px 0',
                width: '100%',
                marginBottom: '12px',
                cursor: 'pointer'
              }}
            >
              <div className="date_delete_container" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px 15px 0',
                fontSize: '12px',
                color: '#666'
              }}>
                <p className="date" style={{
                  margin: 0,
                  fontSize: '12px',
                  color: '#666',
                  fontWeight: '500'
                }}>
                  {moment(item.time || item.date_sent).format("ddd MMM Do YYYY, hh:mm:ss a")}
                </p>
                
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  {/* Individual Notification Count */}
                  {(() => {
                    const individualCount = getIndividualNotificationCount(item);
                    return individualCount > 0 ? (
                      <span 
                        style={{
                          background: '#ff4444',
                          color: 'white',
                          borderRadius: '50%',
                          width: '20px',
                          height: '20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                        }}
                        title={`${individualCount} unread messages`}
                      >
                        {individualCount > 99 ? '99+' : individualCount}
                      </span>
                    ) : null;
                  })()}
                  
                  <Tooltip title="Delete">
                    <img
                      onClick={(e) => onSelectedDelete(e, item)}
                      style={{ width: "24px", height: "24px", cursor: "pointer" }}
                      src={deleteIcon}
                      alt="Delete"
                    />
                  </Tooltip>
                </div>
              </div>
              
              <div style={{ display: "flex", padding: "15px 15px 15px 15px", alignItems: 'flex-start' }}>
                <img
                  style={{
                    width: "50px",
                    borderRadius: "50%",
                    height: "50px",
                    objectFit: "cover",
                    background: "#fff",
                    marginRight: "12px",
                    flexShrink: 0
                  }}
                  src={profileIcon}
                  alt="Profile"
                />
                <div style={{
                  width: "100%",
                  overflow: 'hidden'
                }}>
                  <p style={{
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#333",
                    margin: 0
                  }}>
                    {item?.name || 'Unknown User'}
                  </p>
                  
                  <div style={{
                    fontSize: "13px",
                    color: "#666",
                    lineHeight: "1.4",
                    maxHeight: "60px",
                    overflow: "hidden",
                    marginBottom: "8px"
                  }}>
                    {item?.last_message 
                      ? (item.last_message.length > 80 
                          ? item.last_message.slice(0, 80) + "..." 
                          : item.last_message)
                      : 'No message preview'
                    }
                  </div>
                  
                  {/* Attachment section */}
                  {item?.file_name && item?.attachment_url && (
                    <div style={{ marginTop: "8px" }}>
                      <a
                        href={item.attachment_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        download={item.file_name}
                        style={{ textDecoration: 'none' }}
                      >
                        <button
                          style={{
                            padding: "6px 12px",
                            background: "#008000",
                            color: "#fff",
                            border: "none",
                            cursor: "pointer",
                            borderRadius: "6px",
                            fontSize: "12px",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px"
                          }}
                        >
                          <FontAwesomeIcon icon={faDownload} />
                          Download Attachment
                        </button>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div style={{
          textAlign: 'center',
          padding: '40px 20px',
          color: '#666',
          fontSize: '14px'
        }}>
          No messages found
        </div>
      )}
    </Fragment>
  );
};
export default MessageList;
